import { render, staticRenderFns } from "./TypeDocumentCompanySizeAdmin.vue?vue&type=template&id=a8cc4a3c&"
import script from "./TypeDocumentCompanySizeAdmin.vue?vue&type=script&lang=js&"
export * from "./TypeDocumentCompanySizeAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TypeDocumentCompanySizeAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports